/**
 * Stub: PrintScreenshotsSection is not available in the admin app.
 * This stub exists so that @a7y/ui EngineDetailScreenshot can be resolved by the bundler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
export const PrintScreenshotsSection = (_props: any) => null;
